import React from 'react';
import { Badge } from 'react-bootstrap';

export function getContrastColor(hexColor?: string): string {
  if (!hexColor) return '#ffffff';
  let hex = hexColor.replace('#', '').trim();
  if (hex.length === 3) {
    hex = hex.split('').map(c => c + c).join('');
  }
  if (hex.length !== 6) return '#ffffff';
  const r = parseInt(hex.substring(0, 2), 16) || 0;
  const g = parseInt(hex.substring(2, 4), 16) || 0;
  const b = parseInt(hex.substring(4, 6), 16) || 0;
  // ITU-R BT.709 perceived luminance
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 140 ? '#000000' : '#ffffff';
}

export function getTribeColor(
  tribeName?: string,
  tribes?: { name: string; color: string }[],
  fallbackColor?: string
): string {
  if (fallbackColor && fallbackColor.startsWith('#')) return fallbackColor;
  if (!tribeName || !tribes || tribes.length === 0) return fallbackColor || '#6c757d';
  const match = tribes.find(t => t.name.trim().toLowerCase() === tribeName.trim().toLowerCase());
  return match?.color || fallbackColor || '#6c757d';
}

interface TribeBadgeProps {
  tribeName?: string;
  tribes?: { name: string; color: string }[];
  tribeColor?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const TribeBadge: React.FC<TribeBadgeProps> = ({
  tribeName,
  tribes,
  tribeColor,
  className = '',
  style = {}
}) => {
  if (!tribeName) return null;
  const color = getTribeColor(tribeName, tribes, tribeColor);
  const textColor = getContrastColor(color);

  return (
    <Badge
      className={className}
      style={{
        backgroundColor: color,
        color: textColor,
        border: `1px solid ${color}`,
        fontWeight: 600,
        textShadow: textColor === '#ffffff' ? '0px 1px 1px rgba(0,0,0,0.4)' : 'none',
        ...style
      }}
    >
      {tribeName}
    </Badge>
  );
};

export default TribeBadge;
